
export const categoryInfos = [
  {
    title: "Electronics",
    name: "electronics",
    imgLink: "https://fakestoreapi.com/img/81Zt42ioCgL._AC_SX679_t.png",
  },
  {
    title: "Women's Clothing",
    name: "womens_clothing",
    imgLink: "https://fakestoreapi.com/img/81XH0e8fefL._AC_UY879_t.png",
  },
  {
    title: "Men's Clothing",
    name: "mens_clothing",
    imgLink: "https://fakestoreapi.com/img/71li-ujtlUL._AC_UX679_t.png",
  },
  {
    title: "Jewelery",
    name: "jewelery",
    imgLink:
      "https://fakestoreapi.com/img/71YAIFU48IL._AC_UL640_QL65_ML3_t.png",
  },
];
